
import Vue from 'vue';

import RulesTable from '@/components/entities/rule/RulesTable.vue';
import RuleCreateDialog from '@/components/entities/rule/RuleCreateDialog.vue';
import EntityFiltersCard from '@/components/filters/EntityFiltersCard.vue';
import InfoCard from '@/components/misc/InfoCard.vue';

import RuleService from '@/services/RuleService';
import { extractErrorMessage } from '@/utils/Util';

export default Vue.extend({
  name: 'RulesView',

  components: {
    RulesTable,
    RuleCreateDialog,
    EntityFiltersCard,
    InfoCard,
  },

  data: () => ({
    rules: [] as any[],
    dataLoaded: false,
    dataError: false,
    alertText: '',
    alertType: 'error',
    filters: {} as any,
    filtersConfig: [{ attribute: 'createdAt', always: false }],
  }),

  created() {
    this.updateRules();
  },

  methods: {
    onTableReload() {
      this.updateRules();
    },
    onRuleFiltersApply() {
      this.updateRules();
    },
    onRuleItemUpdate(item: any) {
      this.rules.splice(
        this.rules.findIndex((prop: any) => prop.uuid === item.uuid),
        1
      );
      this.rules.push(item);
    },
    onRuleItemDelete(item: any) {
      this.rules.splice(
        this.rules.findIndex((prop: any) => prop.uuid === item.uuid),
        1
      );
    },
    onRuleCreation(rule: any) {
      this.rules.push(rule);
    },
    async updateRules() {
      this.rules = [];
      this.dataLoaded = false;

      const params: any = {};
      Object.assign(params, this.filters);

      try {
        const rules = await RuleService.getAllCollectionPages(
          this.currentTenant,
          params
        );
        this.rules = rules;
        this.dataLoaded = true;
      } catch (err: any) {
        console.log(err, err.response);
        this.alertType = 'error';
        this.alertText =
          this.$t('rule.loadingError') + ' ' + extractErrorMessage(err);
        this.dataError = true;
        this.dataLoaded = true;
      }
    },
  },
  watch: {
    currentTenant() {
      this.filters = {};
      this.updateRules();
    },
  },
  computed: {
    currentTenant(): any {
      return this.$root.$store.state.session.selectedTenant.uuid;
    },
    canCreate(): any {
      if (
        this.$root.$store.state.session.permissions.resources &&
        'rules' in this.$root.$store.state.session.permissions.resources
      ) {
        return this.$root.$store.state.session.permissions.resources[
          'rules'
        ].includes('POST');
      } else {
        return false;
      }
    },
    lastCreatedAt(): any {
      const occurrences: any = {};
      let sum = 0;

      const pastDate = new Date();
      pastDate.setDate(pastDate.getDate() - 7);

      this.rules.forEach((ruleObj: any) => {
        const _date = new Date(ruleObj.createdAt);
        if (_date >= pastDate) {
          const item = _date.getDate() + '-' + _date.getMonth();
          occurrences[item] = (occurrences[item] || 0) + 1;
          sum = sum + 1;
        }
      });

      return sum;
    },
  },
});
